module.exports = __webpack_public_path__ + "media/images/ac_templates/201/lblht-e75de9a159e338ad2af0009a1e1842cd.jpg";